/**
 * Created by JackCui on 2022/3/11
 */

const typePropsMap = {
  'mini': {
    'paas-file': {
      miniMode: true
    },
    'paas-textArea': {
      showLength: false
    }
  }
}

/**
 * 对应各个字段在不同位置的不同样式
 * 目前以大小为分类去区分不同情况
 * @param fieldType
 * @param size medium small mini (主对象: small, 从对象: mini)
 * @returns {*}
 */
export default function (fieldType, size = 'small') {
  return typePropsMap?.[size]?.[fieldType] || {}
}
